/* istanbul ignore next */
export { default } from './BTLOfferDetailPage';